import { useCallback } from "react";
import { connect, disconnect, isConnected, getLocalStorage } from "@stacks/connect";
import { atom } from "jotai";
import { useUpdateAtom } from "jotai/utils";

export const userDataState = atom();
export const authResponseState = atom();

export const useConnect = () => {
  const setUserData = useUpdateAtom(userDataState);

  const handleOpenAuth = async () => {
    try {
      const response = await connect({ network: 'mainnet' });

      if (response?.addresses?.length > 0) {
        const stxAddress = response.addresses.find(a => a.symbol === 'STX' || a.symbol === 'stx');

        if (stxAddress?.address) {
          setUserData(getLocalStorage());
          window.location.reload();
        }
      }
    } catch (err) {
      if (err?.toString?.()?.includes?.('User cancelled') || err?.toString?.()?.includes?.('closed')) {
        return;
      }
      console.error("Wallet connection failed:", err);
    }
  };

  const handleSignOut = useCallback(() => {
    localStorage.removeItem("userBalances");
    localStorage.removeItem("userVaults");
    localStorage.removeItem("userBNS");
    disconnect();
    window.location.reload();
  }, []);

  return { handleOpenAuth, handleSignOut };
};

export const isUserSignedIn = () => isConnected();

export const getUserAddress = () => {
  const data = getLocalStorage();
  return data?.addresses?.stx?.[0]?.address || null;
};
